const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  ConvertStringToHTML(str) {
    return new DOMParser().parseFromString(str, 'text/html');
  },
  UpdateUrlHistory(newurl) {  
    window.history.replaceState({ path: newurl }, '', newurl);
  },
  ScrollTo(id) {
    const element = document.getElementById(id.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        const $stickyHeader = document.querySelector('.sticky_nav');
        const stickyHeaderHeight = $stickyHeader ? $stickyHeader.style.getPropertyValue('--sticky-header-height') : 0;
        // console.log(`Sticky header height: ${stickyHeaderHeight}`);
        window.scrollBy({
          top: -parseInt(stickyHeaderHeight, 10) || 0,
          behavior: 'smooth'
        });
      }, 1000);
    } 
    else {
      console.warn(`Element with id ${id} not found.`);
    }
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductGrouping', () => ({
    cache: {
      $el: null,
      $product: null
    },
    section_id: '',
    current_product: typeof CURRENT_PRODUCT !== 'undefined' ? CURRENT_PRODUCT : null,
    CURRENT_GROUP: null,
    fits_unique: [],
    selected: {
      department: '',
      style: '',
      fit: ''
    },

    init() {
      this.InitSelf();
      this.InitWatchers();
    },

    InitSelf() {
      let am = this;
      am.cache.$el = am.$el;
      am.cache.$product = am.$el.closest('.shopify-section--product-template');
      am.section_id = am.cache.$product.getAttribute('id').replace('shopify-section-', '');

      let group = JSON.parse(am.$el.dataset.group);
      group.products = JSON.parse(am.$el.dataset.products);
      am.CURRENT_GROUP = group;

      am.$el.classList.toggle('hidden', !am.CURRENT_GROUP);
      document.querySelector('[data-type="styles"]').classList.toggle('hidden', am.CURRENT_GROUP);

      // set fit for first load
      this.$nextTick(() => {
        this.selected.fit = this.GetFits().find(item => item.product.handle == this.current_product.handle).fit;
      });
    },

    InitWatchers() {
      this.$watch('current_product', () => {
        this.$nextTick(() => {
          this.selected.fit = this.GetFits().find(item => item.product.handle == this.current_product.handle).fit;
        });
      });
      this.$watch('selected', () => {
        window.current_product_group = this.selected;
      });
      this.$watch('fits_unique', Alpine.debounce(() => {
        document.dispatchEvent(new CustomEvent('fits-updated', { detail: { fits: this.fits_unique } }));
      }), 300);
    },

    GetProductType(product) {
      let product_type = product.type.split('|');
      let department, fit, style = '';

      if (product.type.indexOf('|') !== -1) {
        department = product_type[0].trim();
        fit = product_type[1].trim();
        style = product_type[2].trim();
      }
      else {
        console.warn('Product type not in correct format:', product.handle);
      }

      let type = { department, fit, style };
      // console.log(product.type, type);
      return type;
    },

    GetCurrentProductType() {
      let am = this;
      return am.GetProductType(am.current_product);
    },    

    GetDepartments() {
      let am = this;
      if (!am.CURRENT_GROUP) return [];
      
      let departments = am.CURRENT_GROUP.departments;

      // if not selected, set first department as selected
      if (!am.selected.department) {
        am.selected.department = am.GetCurrentProductType().department || departments[0];
      }
      
      return departments;
    },

    GetStyles() {
      let am = this;
      if (!am.CURRENT_GROUP) return [];

      let products = am.CURRENT_GROUP.products.map((product) => {
        let type = am.GetProductType(product);
        let department = type.department;
        let style = type.style;
        return { product, department, style };
      });
      let selected_department = am.selected.department;
      let styles = products.filter((item) => item.department == selected_department);

      let styles_map = [...new Set(styles.map(item => item.style))];
      let styles_unique = styles_map.map(style => {
        return styles.find(item => item.style == style);
      });

      // if no matching style, set first style as selected
      if (styles_map.indexOf(am.selected.style) == -1) {
        am.selected.style = styles_map.find(item => item == am.GetCurrentProductType().style) || styles_map[0];
      }

      // console.log({ styles: styles_unique });
      return styles_unique;
    },

    GetFits() {
      let am = this;
      if (!am.CURRENT_GROUP) return [];

      let products = am.CURRENT_GROUP.products.map((product) => {
        let type = am.GetProductType(product);
        let department = type.department;
        let fit = type.fit;
        let style = type.style;
        return { product, department, style, fit };
      });
      let selected_department = am.selected.department;
      let selected_style = am.selected.style;
      let fits = products.filter((item) => item.department == selected_department && item.style == selected_style);

      let fits_map = [...new Set(fits.map(item => item.fit))];
      let fits_unique = fits_map.map(fit => {
        return fits.find(item => item.fit == fit);
      });
      
      this.fits_unique = fits_unique;
      return [...new Set(fits_unique)];
    },

    ChangeDepartment(e) {
      let am = this;
      am.selected.department = e.target.value;
      setTimeout(am.LinkToFirstFitProduct.bind(am), 0);
    },

    ChangeProductStyle(e) {
      let am = this;
      am.selected.style = e.target.value;
      setTimeout(am.LinkToFirstFitProduct.bind(am), 0);
    },

    LinkToFirstFitProduct() {
      let am = this;
      let fits = am.GetFits();
      if (fits.length == 0) return;
      let product = fits[0].product;
      if (!product || !product.handle) return;
      this.LoadProduct(product);
    },

    LinkToProduct(e, product) {
      e.preventDefault();
      if (!product || !product.handle) return;
      this.LoadProduct(product);
    },

    async LoadProduct(product) {
      let am = this;
      if (!product || !product.handle) return;

      let url = `/products/${ product.handle }?section_id=${ am.section_id }`;
      let res = await fetch(url);
      if (!res.ok) {
        console.error('Failed to load product:', product.handle);
        return;
      }

      if (CURRENT_PRODUCT) {
        CURRENT_PRODUCT = product;
      }
      
      let html = await res.text();
      let doc = UTILS.ConvertStringToHTML(html);
      let $newProduct = doc.querySelector('.is-product-main');
      am.cache.$product.replaceWith($newProduct);

      // update url history
      let newurl = `/products/${product.handle}`;
      UTILS.UpdateUrlHistory(newurl);

      // Reinitialize product
      document.dispatchEvent(new Event('DOMContentLoaded'));
    }
  }));

  Alpine.data('SizeChartPopup', () => ({
    tab: 'size-chart',
    init() {
      this.InitSelf();
    },
    InitSelf() {
      // size chart link from tabs
      document.querySelectorAll('a[href*="#fit-guide"]').forEach(($link) => {
        // console.log($link);
        $link.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelector('.product-sizechart-link').click();

          // console.log('Switching to size chart tab');
          window.dispatchEvent(new CustomEvent('switch-size-tab', {
            detail: { tab: 'fit-guide' }
          }));
        });
      });
    }
  }));

  Alpine.data('FitGuide', (fit_guides) => ({
    fit_guides: fit_guides || [],
    fit_guides_toshow: fit_guides || [],
    tab: '',
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      if (this.fit_guides.length > 0) {
        this.$nextTick(() => {
          this.tab = this.fit_guides[0].id;
        });
      }
    },
    InitWatchers() {
      document.addEventListener('fits-updated', Alpine.debounce((e) => {
        let fit_guides_toshow = [...this.fit_guides].filter((guide) => {
          let fits = e.detail.fits.map(fit => fit.fit).join();
          return fits.includes(guide.fit_type) && 
            guide.department == window.current_product_group.department &&
            guide.style == window.current_product_group.style;
        });
        // console.log('Fits updated:', e.detail.fits);
        // console.log('Fit guides to show:', fit_guides_toshow);
        this.fit_guides_toshow = fit_guides_toshow;
        let initial_tab = fit_guides_toshow.find(item => item.fit_type == window.current_product_group.fit)?.id || fit_guides_toshow[0]?.id || '';
        this.tab = initial_tab;
      }), 300);
    }
  }));

  Alpine.data('TagsFilter', () => ({
    block_filter_tags: [],
    preselect_tags: [],
    init() {
      this.InitSelf();
      this.$nextTick(this.PreselectTags.bind(this));
    },
    InitSelf() {
      let block_filter_tags = JSON.parse(this.$el.dataset.block_filter_tags || '[]');
      // console.log('Block Filter tags:', block_filter_tags);
      this.block_filter_tags = block_filter_tags;

      let preselect_tags = JSON.parse(this.$el.dataset.preselect_tags || '[]');
      // console.log('Preselect tags:', preselect_tags);
      this.preselect_tags = preselect_tags;
    },
    PreselectTags() {
      // console.log(this.$el);
      let tags_to_preselect = this.preselect_tags.filter(tag => this.block_filter_tags.join('|').includes(tag));
      
      tags_to_preselect.forEach((tag) => {
        let checkbox = this.$el.querySelector(`[data-filter-tag="${tag}"] input[type="checkbox"]`);
        let active_checkbox = this.$el.querySelector(`.filter-active-tag [data-filter-tag="${tag}"] input[type="checkbox"]`);
        let is_tag_active = active_checkbox && active_checkbox.checked;
        if (checkbox && !is_tag_active) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }) );
        }
      });
    }
  }));

  document.addEventListener('scroll-to', (e) => {
    console.log(e);
    let id = e.detail.id;
    if (id) {
      UTILS.ScrollTo(id);
    }
  });

  // Open chat when clicking on links with href containing #open-chat
  document.querySelectorAll('a[href*="#open-chat"]').forEach(($link) => {
    $link.addEventListener('click', (e) => {
      e.preventDefault();
      Beacon('open');
    });
  });
});